import createLendingBundle from './createBundle'
import whitepaper from './whitepaper.it'
import yieldLadder from './yieldLadder.it'

export default createLendingBundle({ whitepaper, yieldLadder })
